import React, { useEffect, useRef, useState } from "react";
// import { FooterComponents } from "../../components/FooterComponents/FooterComponents";
//import './HomePageScreen.css';
// import 'primeflex/primeflex.css';
// import { Card } from 'primereact/card';
// import { Carousel } from 'primereact/carousel'
import { useParams, useLocation, useHistory } from "react-router-dom";
import { Breadcrumb, Layout, Menu, Button, PageHeader, Row, Col, Form, Input, Select, Skeleton, notification, Card } from 'antd';

import { ECatalogNavigation } from "../../components/ECatalogComponents/ECatalogNavigation";
import "./ProductDetailScreen.css";
import { BsCartPlus } from "react-icons/bs";
//import { useCart } from "react-use-cart";
import { useCart } from "../../Context/CartContext";
import { SearchCatalogItem, GetWolfTemplate, DeleteFavoriteItem, InsertFavoriteItem } from "../../Services/e-pro/EcatalogService";
import { IProductItem } from "../../IRequestModel/ECatalog/IProductItemModel";
import { MapsDataToProductObject, NotificationAddCartSuccess, NumberFormatter, SetViewItemToLocalStorage } from "../../Helper/ECatalogHelper";
import LatestViewProduct from "../../components/ECatalogComponents/LatestViewProduct";
import { MdDoNotDisturbAlt, MdCheckCircle } from "react-icons/md";
import { useUserContext } from "../../Context/UserContext";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useECatalogContext } from "../../Context/ECatalogContext";
import UnAurthorization from "../UnAuthorizePage/UnAurthorization";
import { ECatalogSystemClosed } from "../../components/ECatalogComponents/ECatalogSystemClosed";
interface Props { responeConfig?: { pathLoading?: string } }
const { Header, Content, Footer, Sider } = Layout;
const { Option } = Select;

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 10 },
};
const tailLayout = {
    wrapperCol: { offset: 4, span: 10 },
};

type ProductParams = {
    productId: string;
    // isAutoReport: string;
};
type NotificationType = 'success' | 'info' | 'warning' | 'error';
export function useEffectAsync(effect:any, inputs:any) {
    useEffect(() => {
      return effect();
    }, [effect]);
  } 
export const ProductDetailScreen = (props: Props) => {
    const [userData, setUserData] = useUserContext();
    const [productqty, setProductqty] = useState<any>(1);
    const [productDetail, setProductDetail] = useState<IProductItem>();
    const [defaultImage, setDefaultImage] = useState<string>("");
    const query = new URLSearchParams(useLocation().search);
    const history = useHistory();
    const [isFavorite, setIsFavorite] = useState<boolean>(false);
    
    const checkEcatalog = useECatalogContext();
    const [isAuthorize, setIsAuthorizeo] = useState(true);
    const [isEditECatalog, setIsEditECatalog] = useState(true);

    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        if (checkEcatalog.roleData  != null)
        {
            setIsAuthorizeo(checkEcatalog.canAccess);
            setIsEditECatalog(checkEcatalog.canEdit);
            
        }
        console.log(checkEcatalog);
    }, [checkEcatalog]);

    let productId = query.get("productid");
    
    const [form] = Form.useForm();
    const {
        //isEmpty,
        totalUniqueItems,
        items,
        updateItemQuantity,
        removeItem,
        totalItems,
        addItem
    } = useCart();

    useEffect(() => {
        if (productId != null && productId != ""){
            getProducts().catch(console.error);
        }  
    }, [])
    useEffect(() => {
        if (productId != null && productId != ""){
            setProductDetail(null);
            getProducts().catch(console.error);
            window.scrollTo(0, 0);
        }  
    }, [productId])

    async function getProducts() {
        // const response = await fetch('https://dummyjson.com/products/' + productId)  // fetch the products
        // const data = await response.json() // convert the response to json
        // setProductDetail(data) // set the products in the state to the products we fetched
        // console.log(data);
        const dataJson = {
            searchItem : "",
            Catagoly :0,
            ItemID: productId,
            EmployeeId: userData.EmployeeId
          };
        let response = await SearchCatalogItem(dataJson);
        const data = response.data;
        if (data === null) return;
        let productItem: IProductItem;
        let _tempProductItem: IProductItem[] = MapsDataToProductObject(data);
        productItem = _tempProductItem[0];
        if (productItem.thumbnail != undefined && productItem.thumbnail.length > 0)
        {
            setDefaultImage(productItem.thumbnail[0].ItemPicPath);
        }
        setProductDetail(productItem);
        SetViewItemToLocalStorage(productItem);
        setIsFavorite(productItem?.isFavorite);
        console.log(productItem);
        return productItem;
    }
    const shuffle = (array: any[]) => { 
        return array.sort(() => Math.random() - 0.5); 
    };

    const updateQuantity = (isAdd: boolean, currentStock: number) => {
        var currentQty = parseInt(productqty);
        if (isAdd)
            {
                currentQty = currentQty < currentStock ? currentQty + 1 : currentQty;
            }
        else
            currentQty = currentQty != 1 ? currentQty - 1 : currentQty;
        setProductqty(currentQty);
    }

    const addToCart = () => {

        var currentQty = parseInt(productqty);
        //console.log(items);
        var currentItem = items.filter(x => x.itemId === productDetail.itemId);
        //console.log(currentItem);
        var addCart = false;
        if (currentItem.length === 0){
            addCart = true;
        }else{
            var itemQuantityCheck = currentItem[0].quantity + currentQty;
            if (itemQuantityCheck <= productDetail.itemStock){
                addCart = true;
            }
        }

        if (addCart){
            addItem(productDetail, parseInt(productqty));
            //setProductqty(1);
            NotificationAddCartSuccess();
        }






        //addItem(productDetail, parseInt(productqty));

        //console.log(totalUniqueItems);
        //NotificationAddCartSuccess();
    }

    const handleOrderProduct = async ()=>{
        addToCart();
        history.push(`/cart`);

        //var templateForm = await GetWolfTemplate("PR");

    }
    const updateFavoriteItem = async () => {
        let currentFav = isFavorite;
        setIsFavorite(!isFavorite);
        let jsondata = {
            EmployeeId: userData.EmployeeId,
            ItemID: productDetail.itemId
        }
        if (currentFav){
            await DeleteFavoriteItem(jsondata);
        }
            
        else{
            await InsertFavoriteItem(jsondata);
        }

    }

    if (checkEcatalog.isSystemClosed) {
        return (
            <Layout className="layout">
                <ECatalogNavigation />
                <Content style={{ padding: "15px 10px 0" }}>
                    <ECatalogSystemClosed
                        title={checkEcatalog.systemClosedTitle}
                        message={checkEcatalog.systemClosedMessage}
                    />
                </Content>
            </Layout>
        );
    }

    return  isAuthorize ?  (

        <Layout className="layout">
            <ECatalogNavigation />
            <Content style={{ padding: "15px 10px 0" }}>
                <div className="product-detail-layout-content container">
                    <div className="row product-detail-breadcrumb">
                        <div className="col-12">
                        <Breadcrumb style={{ fontSize:"16px" }} separator=">>" >
                        <Breadcrumb.Item href="/Ecatalog">หน้าแรก</Breadcrumb.Item>
                        {/* <Breadcrumb.Item href="/ECatalog">E-Catalog</Breadcrumb.Item> */}
                        {
                            productDetail != null ? (<Breadcrumb.Item>{productDetail.title} </Breadcrumb.Item>) : (<></>)
                        }

                    </Breadcrumb>
                        </div>
                    
                    </div>
                    <div className="row product-item">
                        <div className="col-sm-12 col-md-4 product-image">
                            <div className="flex flex-column">
                                <div className="product-image-detail">
                                    <div className="product-image-container">
                                        <picture>
                                            {
                                                productDetail != null ? (
                                                    productDetail.thumbnail != null ? (
                                                        <img className="IMAW1w" src={defaultImage} alt={productDetail.title} />
                                                    ) : (<></>)
                                                   
                                                ) : (<Skeleton.Image />)
                                            }

                                        </picture>
                                    </div>
                                    {
                                        productDetail != null ? (
                                            <div className="row my-2" >
                          
                                                   {
                                                    productDetail.thumbnail?.map((image:any) => {
                                                       return <div className="col-2 product-image-small" onClick={() => { setDefaultImage(image.ItemPicPath);}}> <img className="IMAW1w" src={image.ItemPicPath} alt={productDetail.title} /></div>
                                                    })
                                                   }
                                            </div>
                                        ) : (<></>)


                                    }
                                    
                                </div>
                            </div>
                        </div>
                        <div className="col-8 product-detail">
                            <div className="product-detail-content">
                                <div className="product-title">
                                    <span>{
                                        productDetail != null ? (
                                            <> {productDetail.title}</>
                                        ) : (<Skeleton />)


                                    }</span>
                                </div>
                                
                                <div className="product-desc">
                                    <div className="product-desc-code">
                                        
                                        {
                                            productDetail != null ? (
                                                <div>รหัสสินค้า :
                                                    {
                                                        productDetail.itemId != null ? (
                                                            <> {productDetail.itemId}</>
                                                        ) : (<> -</>)
                                                    }
                                                   
                                                </div>
                                               
                                            ) : (<Skeleton />)
                                        }
                                    </div>
                                    <div className="product-desc-detail">
                                        {
                                            productDetail != null ? (
                                                <> {productDetail.description}</>
                                            ) : (<Skeleton />)
                                        }
                                    </div>
                                </div>
                                <div className="product-price">
                                    <div className="product-price-detail">
                                        {
                                            productDetail != null ? (
                                                <> 
                                                    ฿ { NumberFormatter(productDetail.price) }
                                                    {/* {productDetail.price?.toFixed(2)} */}
                                                
                                                </>
                                            ) : (<Skeleton />)
                                        }
                                    </div>
                                    <div className="text-gray-600 text-sm">
                                        {
                                             productDetail != null ? (
                                                
                                                    
                                                        productDetail.itemStock > 0 ? (
                                                            <>
                                                            <div className="product-item-have-stock"><MdCheckCircle/> สินค้าพร้อมส่ง</div>
                                                            <div>เหลือ { productDetail.itemStock } { productDetail.itemUnit}</div>
                                                            </>
                                                        ) : (<> <div className="product-item-no-stock"><MdDoNotDisturbAlt/> สินค้าหมดชั่วคราว</div></>)
                                                    
                                                   
                                                
                                               
                                            ) : (<Skeleton />)
                                        }
                                    </div>
                                    <div className="text-gray-600 text-sm pt-2">
                                    {
                                             productDetail != null ? (
                                                <>
                                                    ผู้ค้า : { productDetail.sellerName }
                                                </>
                                                
                                               
                                            ) : (<Skeleton />)
                                        }
                                    
                                    </div>

                                </div>
                                {
                                    productDetail != null ? (
                                    productDetail.itemStock > 0 && isEditECatalog ? (
                                        <>                
                                        <div className="product-quantity">
                                   <section style={{ display: "flex", alignItems: "center" }}>
                                       <h3 className="Dagtcd">จำนวน</h3>
                                       <div style={{ display: "flex", alignItems: "center" }}>
                                           <button className="product-qty-btn btnDecrease" onClick={() => updateQuantity(false, productDetail.itemStock)}>-</button>
                                           <input className="product-qty-btn txtInput" type="number" min={1}  max={productDetail.itemStock} role="spinbutton" aria-live="assertive" defaultValue={productqty} value={productqty}  
                                        //    onChange={e => {
                                        //     if (e.target.value != "" && e.target.value != "0" && e.target.value.indexOf('-') < 0){
                                            
                                        //         var currentValue = parseInt(e.target.value);
                                        //         if (currentValue <= productDetail.itemStock){
                                        //            setProductqty(currentValue);
                                        //         }else{
                                        //            setProductqty(productDetail.itemStock);
                                        //         }
                                        //     }
                                        //     else
                                        //     {
                                        //         if (e.target.value != "")
                                        //             setProductqty(1)
                                        //     }
                                        //    }} 
                                           onChange={(e) => {
                                            const val = e.target.value;
                                        
                                            // Allow empty string
                                            if (val === "") {
                                              setProductqty("");
                                              return;
                                            }
                                        
                                            // Block negative and zero
                                            if (/^\d+$/.test(val) && parseInt(val) > 0) {
                                              const parsed = parseInt(val);
                                              setProductqty(
                                                parsed > productDetail.itemStock ? productDetail.itemStock.toString() : val
                                              );
                                            }
                                          }}
                                           
                                           onBlur={ (e) => {
                                            if (productqty === "" || parseInt(productqty) < 1){
                                                setProductqty(1)
                                            }
                                           }}  ></input>
                                           <button className="product-qty-btn btnIncrease" onClick={() => updateQuantity(true, productDetail.itemStock)}>+</button>
                                       </div>
                                       <div style={{marginLeft:"6px"}}>{ productDetail.itemUnit }</div>
                                   </section>


                                       </div>
                                       <div className="product-action" style={{ marginTop: "15px" }}>
                                           <div style={{ paddingLeft: "20px" }}>
                                               <div className="product-action-button-group">
                                                   <Button type="primary" htmlType="button" className="product-action-addcart-button"
                                                       icon={<BsCartPlus style={{ width: "20px", height: "20px", marginRight: "10px" }} />}
                                                       onClick={addToCart}>
                                                       เพิ่มลงตะกร้า
                                                   </Button>
                                                   <Button type="primary" htmlType="button" className="product-action-buy-button" onClick={handleOrderProduct}>
                                                       ขอสั่งซื้อสินค้า
                                                   </Button>
                                                   <button className="product-item-fav-btn" onClick={(event) => { event.stopPropagation(); updateFavoriteItem(); }} >   
                                                    {
                                                        isFavorite ? <FaHeart/>  : <FaRegHeart />
                                                    }
                                                </button>
                                               </div>
                                           </div>

                                       </div>
                                   </>

                                    ) : (<></>)
                                    ) : (<></>)
                                }
                               
                            </div>
                        </div>
                    </div>
                    {/* <section className="product-item">
                        
                        <section className="product-image">
                           
                        </section>
                        <section className="product-detail">
                            
                        </section>
                    </section> */}
                    <div className="row product-content">
                        <div className="col-12 px-0">
                            <Card className="ecatalog-form-search-card"  bordered={false} title="รายละเอียดสินค้า" size={"small"}>
                                {
                                    <div
                                        dangerouslySetInnerHTML={{
                                        __html: productDetail?.itemProperties,
                                        }}
                                    />
                                }
                            </Card>
                            

                        </div>
                    </div>
                    <div className="row product-content-lastitem">
                        <div className="col-12 px-0">
                        <Card className="ecatalog-form-search-card" bordered={false} title="สินค้าเข้าชมล่าสุด" size={"small"}>
                            {/* <Products showSlide={true} limitItem={2} /> */}
                            <LatestViewProduct/>
                        </Card>
                        </div>
                    </div>
                   
                </div>




            </Content>
        </Layout>
    ) : ( <UnAurthorization />);
};